const ImportTabCtrl = ['$scope', 'UserInfo',
    function ($scope, UserInfo) {
        $scope.selectedTab = 'import';
    }
]

export { ImportTabCtrl }
